import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Proprietaires from "@/pages/Proprietaires";
import Collection from "@/pages/Collection";
import ListingDetail from "@/pages/ListingDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import OwnerFormPage from "@/pages/OwnerFormPage";
import Legal from "@/pages/Legal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <LanguageProvider>
        <BrowserRouter>
          <Toaster position="top-center" />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/proprietaires" element={<Proprietaires />} />
              <Route path="/collection" element={<Collection />} />
              <Route path="/collection/:slug" element={<ListingDetail />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/confier-mon-bien" element={<OwnerFormPage />} />
              <Route path="/mentions-legales" element={<Legal slug="mentions-legales" />} />
              <Route path="/confidentialite" element={<Legal slug="confidentialite" />} />
              <Route path="/cookies" element={<Legal slug="cookies" />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        </LanguageProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
